/** Guided labels for retriever Search Type dropdown (Create / Edit project). */

export const RETRIEVER_SEARCH_TYPE_OPTIONS = [
  {
    value: 'hybrid',
    label: 'Hybrid (recommended)',
    title: 'Hybrid (recommended)',
    subtitle:
      'Best mix of keyword + meaning — IDs, product names, and normal questions',
  },
  {
    value: 'similarity',
    label: 'Similarity',
    title: 'Similarity',
    subtitle: 'Simple semantic search — good for explain / summarize style questions',
  },
  {
    value: 'mmr',
    label: 'Diverse results (MMR)',
    title: 'Diverse results (MMR)',
    subtitle: 'Use when retrieved sources feel repetitive or too similar',
  },
];

export const DEFAULT_RETRIEVER_SEARCH_TYPE = 'hybrid';

export function retrieverSearchTypeLabel(value) {
  const id = value || DEFAULT_RETRIEVER_SEARCH_TYPE;
  return RETRIEVER_SEARCH_TYPE_OPTIONS.find((o) => o.value === id)?.label ?? id;
}
